import type { ReactNode, RefObject } from "react";
import { Button } from "@corpuscomplete/web-ui/components/button";
import { Text } from "@corpuscomplete/web-ui/components/text";
import { PendingActionCard } from "@corpuscomplete/web/modules/common/agent-chat/pending-action-card";

type PendingHumanToolCardProps = {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  headerRight?: ReactNode;
  footerActions?: ReactNode;
  contentHeight?: number;
  contentRef?: RefObject<HTMLDivElement | null>;
  progressLabel?: string;
  upNextLabel?: string;
  isActive: boolean;
  isPersisted: boolean;
  canCancel: boolean;
  onCancel: () => void;
};

export function PendingHumanToolCard({
  title,
  icon,
  children,
  headerRight,
  footerActions,
  contentHeight,
  contentRef,
  progressLabel,
  upNextLabel,
  isActive,
  isPersisted,
  canCancel,
  onCancel,
}: PendingHumanToolCardProps) {
  return (
    <PendingActionCard
      icon={icon}
      title={title}
      contentHeight={contentHeight}
      contentRef={contentRef}
      className={!isActive ? "opacity-70" : undefined}
      headerRight={
        <div className="flex items-center gap-2">
          {headerRight}
          {progressLabel && (
            <Text variant="xs" className="text-muted-foreground">
              {progressLabel}
            </Text>
          )}
        </div>
      }
      footer={
        <div className="flex w-full items-center justify-between gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={onCancel}
            disabled={!isActive || !isPersisted || !canCancel}
          >
            Cancel
          </Button>
          <div className="flex items-center gap-2">{footerActions}</div>
        </div>
      }
    >
      <div className="space-y-3">
        {!isActive && (
          <Text variant="xs" className="text-muted-foreground">
            Complete the earlier step to continue.
          </Text>
        )}
        {isActive && !isPersisted && (
          <Text variant="xs" className="text-muted-foreground">
            Syncing step before actions become available.
          </Text>
        )}
        {upNextLabel && isActive && (
          <Text variant="xs" className="text-muted-foreground">
            Up next: {upNextLabel}
          </Text>
        )}
        {children}
      </div>
    </PendingActionCard>
  );
}
